export function isFileSizeLessThanOrEqualTo(file: File, sizeInMegaBytes: number) {
    const fileSizeInBytes = file.size;
    const fileSizeInKilobytes = fileSizeInBytes / 1024;
    const fileSizeInMegabytes = fileSizeInKilobytes / 1024;

    return fileSizeInMegabytes <= sizeInMegaBytes;
}
